/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientTicketDto } from '../../models/client-ticket-dto';

export interface ClientTicketControllerFindAll$Params {
}

export function clientTicketControllerFindAll(http: HttpClient, rootUrl: string, params?: ClientTicketControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientTicketDto>>> {
  const rb = new RequestBuilder(rootUrl, clientTicketControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientTicketDto>>;
    })
  );
}

clientTicketControllerFindAll.PATH = '/api/client-ticket';
